import { b } from './chunk-IMSWER4T.js';

var p=class extends b{URL="export-mappings";async duplicate(t){return (await this._client.post(`/${this.URL}/duplicate`,t)).data}async doesExportMappingExist(t){return (await this._client.get(`/${this.URL}/exists?module_id=${t.module_id}&datamodel_id=${t.datamodel_id}`))?.data?.exists}async orderMappingItem(t,r,o){await this._client.post(`/${this.URL}/${t}/items/${r}/order`,o);}};

export { p as a };
//# sourceMappingURL=chunk-IWO2QTF4.js.map
//# sourceMappingURL=chunk-IWO2QTF4.js.map